import React from 'react'
import '../../styles/scss/components/equote-error-page.scss'

import default404Image from '../../assets/images/Page-Not-Found_Hero.jpg'
import brandLoader from '../../assets/icons/brand-loader-final.gif'

const ErrorPage = props => {
  const { errorStatus, labelsErrorDetails } = props
  const errorDetails = labelsErrorDetails[errorStatus]

  const privacyLink = document.querySelector('.equote__footer-links')
  privacyLink.style.display = 'none'

  return (
    <>
      {!labelsErrorDetails.loading ? (
        <div
          className="equote-error-page"
          style={{
            backgroundImage:
              labelsErrorDetails &&
              labelsErrorDetails['404'] &&
              labelsErrorDetails['404'].image.file
                ? 'url(' + labelsErrorDetails['404'].image.file + ')'
                : 'url(' + default404Image + ')'
          }}
        >
          <div className="equote-error-page--content">
            <div className="equote-error-page--content--text-container">
              {errorDetails && errorDetails.title ? (
                <h1>{errorDetails.title}</h1>
              ) : (
                <h1>Internal Server Error</h1>
              )}
              {Boolean(errorDetails && errorDetails.body) && (
                <p>{errorDetails.body}</p>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div
          className="u-loading-spinner"
          style={{
            flex: 1
          }}
        >
          <img src={brandLoader} alt="loading..." />
        </div>
      )}
    </>
  )
}

export default ErrorPage
